import { Button } from '@mui/material'
import ExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMore from '@mui/icons-material/ExpandMore'
import { useState } from 'react'

export default function ShowDetailsOfSelectedPlan({ planData, unSecureSetupData }) {
  const [showAllPlans, setShowAllPlans] = useState(false)

  const matrixArray = Object.keys(planData?.pricingMatrix || {})?.map((key) => [
    key,
    planData?.pricingMatrix[key],
  ])

  function toggleShowAllPlans() {
    setShowAllPlans((prev) => !prev)
  }

  return (
    <div>
      {/* <span>
          {
            unSecureSetupData?.metaCountries?.find(
              (countryItem) => countryItem?.currency === planData?.currency,
            )?.currencySymbol
          }
        </span>
        <span style={{ textDecoration: 'line-through' }}>{planData?.price}</span>
        <span style={{ marginLeft: '10px', fontWeight: '700' }}>
          {
            unSecureSetupData?.metaCountries?.find(
              (countryItem) => countryItem?.currency === planData?.currency,
            )?.currencySymbol
          }
        </span>
        <span style={{ fontWeight: '700' }}>{planData?.finalPrice}</span> */}
      {!Boolean(planData) && <span style={{ color: 'red' }}>No Plan Selected</span>}
      <Button
        color="primary"
        size="small"
        onClick={toggleShowAllPlans}
        endIcon={showAllPlans ? <ExpandLess /> : <ExpandMore />}
      >
        {!showAllPlans ? 'Show More Details' : 'Hide Details'}
      </Button>
      {showAllPlans &&
        matrixArray?.map((matrixItem, matrixItemIndex) => {
          const countryData = unSecureSetupData?.metaCountries?.find(
            (countryItem) => countryItem?.id === matrixItem?.[0],
          )
          const currencySymbol = unSecureSetupData?.metaCountries?.find(
            (countryItem) => countryItem?.currency === matrixItem?.[1]?.currencyId,
          )?.currencySymbol

          return (
            <div key={matrixItemIndex}>
              <div>
                <b>
                  {countryData?.id === 'row' ? 'Global (Rest of the World)' : countryData?.name}
                </b>
              </div>
              <div>
                <span style={{ textDecoration: 'line-through' }}>
                  {currencySymbol}
                  {matrixItem?.[1]?.price}
                </span>{' '}
                @{' '}
                <span>
                  {currencySymbol}
                  {matrixItem?.[1]?.discountedPrice}
                </span>
              </div>
            </div>
          )
        })}
    </div>
  )
}
